import { onMailSearchBoxContainerInitialized, onOwaResized } from '../actions/bootActions';
import getNewSearchBoxWidth from '../selectors/getNewSearchBoxWidth';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
mutator(onMailSearchBoxContainerInitialized, function () {
    updateSearchBoxWidth();
});
mutator(onOwaResized, function () {
    updateSearchBoxWidth();
});
function updateSearchBoxWidth() {
    getStore().searchBoxWidth = getNewSearchBoxWidth();
}
//# sourceMappingURL=searchBoxWidthMutators.js.map